/**
 * The firm's title instructions: how it likes exhibits titled, in its own
 * words or as a format per document type. The firm's title template
 * (`default_title_template`) takes one line of known fields and is rendered
 * by code, so a free or multi-line style is saved as `title_instructions`
 * (see `CASE_PREP_FIELDS`), and Retitle Exhibits has Casey write the titles
 * that follow it.
 */
import type { TitleTemplate } from "@/api/types/lawFirm";

/** A firm's saved one-line template as style lines, to start the box from. */
export const styleFromTemplate = (template: TitleTemplate | null): string => {
  const byType = Object.entries(template?.by_type ?? {}).map(
    ([kind, format]) => `${kind}: ${format}`
  );
  const fallback = template?.default?.trim() ?? "";
  if (!byType.length) return fallback;
  return [...byType, fallback ? `Everything else: ${fallback}` : null]
    .filter((line): line is string => Boolean(line))
    .join("\n");
};
